module.exports = __webpack_public_path__ + "img/news-boy.458ba1e5.png";